export const formatMimeType = (mimeType: string): string => {
  const types: { [key: string]: string } = {
    'application/pdf': 'PDF',
    'application/zip': 'ZIP',
    'application/x-zip-compressed': 'ZIP',
    'image/png': 'PNG',
    'image/jpeg': 'JPEG',
    'image/gif': 'GIF',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      'Excel',
    'application/vnd.ms-excel': 'Excel',
    'text/csv': 'CSV',
    'application/msword': 'DOC',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      'DOCX',
    'text/plain': 'Text',
    'application/json': 'JSON',
  }

  return types[mimeType] || 'File'
}

export const formatSize = (size: any) => {
  return `${(size / 1024).toFixed(1)} KB`
}
